module.exports = __webpack_public_path__ + "image/CN_News2_CN_photo.1782790484418.jpg";